

function LeadershipTier6DesignTemplate() {
    return (
        <div>
            <hr className="HorizontalLineBlue" />
            <b className="AbilityHeader animationcolorWhiteOrangeFlashing">DESIGN INSIGHTS</b>
            <hr className="HorizontalLineBlue" />
            <div className="animationFadeIn">
                This talent is designed to give you a new means of controlling the movement on the battlefield, 
                but in a way that comes at personal cost.
                <br />
                A clever Leader is a very impactful force-multiplier in every skirmish.
            </div>
            <p>
                <b className="AbilityHeaderSmall">WHY THE MOVEMENT LIMITATIONS?</b>
                <div className="animationFadeIn">
                    This was done as a means of creating tactical choice. On your turn you could move,
                    or you could let an ally who absolutely needs to move shift their position.
                    It isn't always the right move to use On The Move and that's the point.
                    The player expresses mastery by choosing the right tool for the right job in their vast toolset.
                    <br />
                    If an ally needs to get out of opportunity attack range, remember that you could instead issue a Command - En Passant.
                    <br /> 
                    You could also combine En Passant with On The Move to create a powerful burst of movement
                    speed for a teamate to help them get into position or escape a pursuer!
                </div>
            </p>
            <p>
                <b className="AbilityHeaderSmall">THEMING</b>
                <div className="animationFadeIn">
                On The Move is a reference to the military jargon, <b>O</b>scar <b>M</b>ike 
                which is <b>OM</b> in the NATO Alphabet, short for "<b>O</b>n the <b>M</b>ove".
                </div>
            </p>
            <br />
        </div>
    )
}

export { LeadershipTier6DesignTemplate };